export const printInitials = (fullName: string) => {
  let splitName = fullName
    .split(' ')
    .map((name) => {
      return name[0];
    })
    .join('');
  return splitName;
};
